import { Injectable } from '@angular/core';
import { MainService } from "./main.service";
import { HttpClient } from "@angular/common/http";
import { ToastService } from 'src/app/services/toast.service';
import { StorageService } from 'src/app/services/storage.service';
import { DomSanitizer } from '@angular/platform-browser';
// import { resolve } from 'url';
import { Router } from '@angular/router';
import * as $ from 'jquery';

@Injectable({
  providedIn: 'root'
})
export class CmsService extends MainService {

	/**
	 * this is the replacement of the activeItems in header component
	 * instead of json data it is now in html format
	 */
	headerMenuBtn:any = '';
	headerMenuBtnContent:any = '';

	public cms: any = {};

	constructor(
		public http: HttpClient,
		public toastService: ToastService,
		public storage: StorageService,
		public sanitizer: DomSanitizer,
		public router: Router,
	) {
		super(http, toastService, storage, router);
	}

  getBlock(id, sanitize:boolean = false, toJson: boolean = false){
  	let storageName = 'cms_block_' + id;
  	let blockName = 'block_' + id;
  	return new Promise (cmsblock => {
		this.get(this.getStoreUrl('/V1/cmsBlock/'+id)).subscribe(result => {
			if(toJson) {
				result.content = JSON.parse(result.content);
			}
			if(sanitize) {
				result.content = this.sanitizer.bypassSecurityTrustHtml(result.content);
			}
			this.cms[blockName] = result;
			cmsblock(result);
		});


		/**
		 * server side caching is now available
		 */
	  	// this.storage.get(storageName).then(resolve => {
		// 	if(!resolve){
		// 		this.get('/rest/entrelable/V1/cmsBlock/'+id)
		// 	    .subscribe(result => {
		// 			if(toJson) {
		// 				result.content = JSON.parse(result.content);
		// 			}
		// 	    	this.storage.setLocal(storageName, result); 
		// 	    	if(sanitize) {
		// 				result.content = this.sanitizer.bypassSecurityTrustHtml(result.content);
		// 			}
		// 	      	this.cms[blockName] = result;
		// 	      	cmsblock(result);
		// 	    });
		// 	} else {
		// 		let data: any = resolve;
		//     	if(sanitize) {
		// 			data.content = this.sanitizer.bypassSecurityTrustHtml(data.content);
		// 		}
		// 		this.cms[blockName] = data;
		// 		cmsblock(data);
		// 	}
		// });
	});
  }

  getBlockv2(id, sanitize:boolean = false, toJson: boolean = false): any{

	return new Promise (resolve => {
		this.get('/rest/entrelable/V1/cmsBlock/'+id)
		.subscribe(result => {
			if(toJson) {
				result.content = JSON.parse(result.content);
			}
			if(sanitize) {
				result.content = this.sanitizer.bypassSecurityTrustHtml(result.content);
			}
			resolve(result);
		});
	}); 
  }

  getPage(id, sanitize:boolean = false, toJson: boolean = false): any{

	return new Promise (resolve => {
		this.get('/rest/entrelable/V1/cmsPage/'+id)
		.subscribe(result => {
			if(toJson) {
				result.content = JSON.parse(result.content);
			}
			if(sanitize) {
				result.content = this.sanitizer.bypassSecurityTrustHtml(result.content);
			}
			resolve(result);
		});
	}); 
  }

	getHndCmsPage(name, sanitize:boolean = false, toJson: boolean = false, targetEl:string=''): any{
		return new Promise (resolve => {
			let url = this.getStoreUrl('/V1/hnd-common/cms/page/content/' + name);
			this.get(url).subscribe(result => {
				if(targetEl.length){
					result.content = this.convertImgSrc(result.content, targetEl);
				}
				setTimeout(() => {
					if(toJson) {
						result.content = JSON.parse(result.content);
					}
					if(sanitize) {
						result.content = this.sanitizer.bypassSecurityTrustHtml(result.content);
					}
					resolve(result);
				}, 100);
			});
		}); 
	}

	/**
	 * this will convert csm image source to full magento image link
	 * the element must have attr data-src and the data-src content must not have 
	 * domain name e.g: 
	 * https://domain.com/media/your/image/imagename.png must be /media/your/image/imagename.png
	 * 
	 * @param htmlConent string an HTML content came from CSM api
	 * @param targetEl string must be the class name of an element
	 */
	convertImgSrc(htmlConent:string, targetEl:string){
		let htmlEl = $('<div>' + htmlConent + '</div>');
		let images = htmlEl.find( targetEl );
		$.each(images, (key, image) => {
			let el = $(image);
			const imgSrc = el.data('src');
			if(imgSrc != 'hnd-cms-src-inserted'){
				el.attr('src', this.getUrl(imgSrc));
				el.attr('data-src', 'hnd-cms-src-inserted');
			}
		});
		return htmlEl.html();
	}
}
